import {FC, useMemo} from 'react';
import {Col, Row} from 'react-bootstrap';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import {FormPageHeader, FormPageFooter} from "@components/falcon/common/forms";
import {RewardBaseInfoBlock, RewardContentBlock, RewardTypeBlock} from "../forms";
import {GoalRewardFormValues} from "../forms/rewardBaseInfoBlock";

import {GoalRewardType} from "@interfaces/consumer/refs";

interface GoalRewardFormProps {
    initialValues: GoalRewardFormValues;
    onSubmit: (values: GoalRewardFormValues) => Promise<any>;
    editForm?: boolean;
    title: string;
    cancelUrl: string;
}

const GoalRewardForm: FC<GoalRewardFormProps> = ({
    initialValues,
    onSubmit,
    editForm,
    title,
    cancelUrl
}) => {

    const validationSchema = useMemo(() => Yup.object<GoalRewardFormValues>({
        name: Yup.string()
            .max(256)
            .required(),
        order: Yup.number()
            .min(-65000)
            .max(65000)
            .required(),
        isActive: Yup.boolean()
            .required(),
        type: Yup.mixed<GoalRewardType>()
            .oneOf([GoalRewardType.Balance, GoalRewardType.Item])
            .required(),
        balance: Yup.number()
            .when("type", {
                is: GoalRewardType.Balance,
                then: schema => schema
                    .min(1)
                    .max(1000000)
                    .required()
            }),
        itemId: Yup.string()
            .when('type', {
                is: GoalRewardType.Item,
                then: schema => schema
                    .required()
            }),
        count: Yup.number()
            .when('type', {
                is: GoalRewardType.Item,
                then: schema => schema
                    .min(1)
                    .max(2000000000)
                    .required()
            })
    }), []);

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            enableReinitialize
        >
            <Form>
                <Row className="g-3">
                    <Col lg={12}>
                        <FormPageHeader title={title} />
                    </Col>
                    <Col lg={8}>
                        <RewardBaseInfoBlock editForm={editForm} />
                        {!editForm && <RewardTypeBlock />}
                    </Col>
                    <Col lg={4}>
                        <RewardContentBlock />
                    </Col>
                    <Col>
                        <FormPageFooter cancelUrl={cancelUrl} />
                    </Col>
                </Row>
            </Form>
        </Formik>
    );
};

export default GoalRewardForm;
